<template>
  <div>
    <div class="subpage-gallery" :class="['subpage-gallery--' + imgCount, galleryClass]">
      <div class="subpage-gallery__col big">
        <div class="subpage-gallery__item" @click="openGallery(0)">
          <img :src="gallery[0].filename" alt="" class="subpage-gallery__img">
        </div>
      </div>
      <div class="subpage-gallery__col">
        <div class="subpage-gallery__item"
             v-for="(img, $index) in gallery.slice(1, imgCount)" :key="img.id"
             @click="openGallery($index + 1)">
          <img :src="img.filename" alt="" class="subpage-gallery__img">
        </div>
      </div>
    </div>
    <modal :active="showModal" modal-class="modal-gallery" @onModalClose="closeGallery">
      <div slot="content">
        <transition-group tag="div" class="modal-gallery__list" name="fade">
          <div v-for="(img, index) in gallery" :key="img.id"
               class="modal-gallery__item"
               :class="{ active : index === currentItem }"
               v-show="index === currentItem">
            <img
              :src="img.filename"
              alt=""
              class="modal-gallery__img">
          </div>
        </transition-group>
        <v-button
          class="green modal-gallery__button prev"
          icon="icon-arrow-left"
          icon-position="left"
          @click.native="prevItem"
        />
        <v-button
          class="green modal-gallery__button next"
          icon="icon-arrow-right"
          icon-position="left"
          @click.native="nextItem"
        />
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'SubpageGallery',
  props: {
    gallery: Array,
    galleryClass: String,
    imgCount: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      showModal: false,
      currentItem: null
    }
  },
  methods: {
    openGallery (index) {
      this.showModal = true
      this.currentItem = index
    },
    closeGallery () {
      this.showModal = false
    },
    prevItem () {
      if (this.currentItem > 0) {
        this.currentItem--
      } else {
        this.currentItem = this.gallery.length - 1
      }
    },
    nextItem () {
      if (this.currentItem < this.gallery.length - 1) {
        this.currentItem++
      } else {
        this.currentItem = 0
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/components/subpage-gallery";
</style>
